export default __webpack_public_path__ + "static/media/who-01.5cc37edc.svg";